module.exports = __webpack_public_path__ + "img/liked.6c7ad130.svg";